<template>
  <p>
    {{ text('context_info.SHOP.p1') }}
  </p>
  <p>
    {{ text('context_info.SHOP.p2') }}
  </p>
</template>

<script setup>
import text from '~/text';
</script>
